import {
  ExtractFnReturnType,
  InfiniteQueryConfigType,
  useInfiniteQuery,
  UseInfiniteQueryResult,
} from "~/libs";

import { ApiClient } from "~/utils";

import {
  ApiManagersEmployeeConditionSurveysIndexResponseType,
  ApiManagersEmployeeConditionSurveysIndexRequestType,
} from "~/domains";

type RequestDataType = {
  params?: ApiManagersEmployeeConditionSurveysIndexRequestType;
  page?: number;
};

const request = async ({
  params,
  page = 1,
}: RequestDataType): Promise<ApiManagersEmployeeConditionSurveysIndexResponseType> => {
  const response =
    await new ApiClient().get<ApiManagersEmployeeConditionSurveysIndexResponseType>(
      "/api/managers/employee_condition_surveys",
      { page, ...params },
    );
  return response.data;
};

type QueryFnType = typeof request;

type PropsType = {
  params?: ApiManagersEmployeeConditionSurveysIndexRequestType;
  config?: InfiniteQueryConfigType<QueryFnType>;
};

export const useApisManagersEmployeeConditionSurveysIndex = ({
  params,
  config = {},
}: PropsType = {}): UseInfiniteQueryResult<ApiManagersEmployeeConditionSurveysIndexResponseType> => {
  return useInfiniteQuery<ExtractFnReturnType<QueryFnType>>(
    ["ApisManagerEmployeeConditionSurveysIndex", params],
    ({ pageParam }) => {
      return request({ params, page: pageParam as number | undefined });
    },
    {
      ...config,
    },
  );
};
